var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBillingHistory = function SvgBillingHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0696 0.25V6.43238H12.7257L12.726 13.75L9.89567 12.3485L7.50232 13.558L5.10896 12.3485L2.29328 13.7396L2.29289 6.43238H0V0.25H15.0696ZM11.5665 3.9204H3.45209V11.874L5.11476 11.0529L7.50232 12.2585L9.89104 11.0529L11.5665 11.8821V3.9204ZM9.82651 8.34351V9.5027H5.18972V8.34351H9.82651ZM9.82651 5.68006V6.83926H5.18972V5.68006H9.82651ZM13.9104 1.40881H1.1592V5.2728H2.29289L2.29328 2.76121H12.726L12.7257 5.2728H13.9104V1.40881Z",
    fill: "#595959"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBillingHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/billingHistory.25e5a1e1.svg";
export { ForwardRef as ReactComponent };